import { useState } from "react";
import { api, errorMessage } from "@/lib/api";
import { isEmail } from "@/lib/format";

const SUCCESS = "You're on the list. We'll only write once or twice a year.";
const INVALID = "Please enter a valid email address.";

export function NewsletterForm({ idPrefix, dark = false }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    if (!isEmail(email)) return setState({ status: "error", msg: INVALID });
    setState({ status: "busy", msg: "" });
    try {
      await api.post("/newsletter", { email: email.trim() });
      setState({ status: "done", msg: SUCCESS });
      setEmail("");
    } catch (err) {
      const msg = err?.response?.status === 422 ? INVALID : errorMessage(err, "We couldn't add you just now. Please try again.");
      setState({ status: "error", msg });
    }
  };

  const id = `${idPrefix}-newsletter-email`;
  const hasError = state.status === "error";
  return (
    <form onSubmit={submit} noValidate className="w-full" data-testid={`${idPrefix}-newsletter-form`}>
      <label htmlFor={id} className={`of-label ${dark ? "text-white" : ""}`}>Your email</label>
      <div className="flex flex-col gap-2 sm:flex-row">
        <input id={id} type="email" autoComplete="email" inputMode="email" className="of-input sm:flex-1" value={email}
          onChange={(e) => setEmail(e.target.value)} aria-invalid={hasError} aria-describedby={`${id}-msg`}
          placeholder="you@example.com" data-testid={`${idPrefix}-newsletter-email-input`} />
        <button type="submit" className={dark ? "of-btn bg-[#F5AE3D] text-[#1F2328] hover:bg-[#FFC25C]" : "of-btn-soft"}
          disabled={state.status === "busy"} data-testid={`${idPrefix}-newsletter-submit-button`}>
          {state.status === "busy" ? "Adding…" : "Join the list"}
        </button>
      </div>
      <p id={`${id}-msg`} role="status" aria-live="polite"
        className={`mt-2 min-h-[1.25rem] text-sm font-medium ${hasError ? (dark ? "text-[#FFB4A8]" : "text-[#B42318]") : dark ? "text-[#F5AE3D]" : "text-[#1E6B47]"}`}
        data-testid={`${idPrefix}-newsletter-message`}>
        {state.msg}
      </p>
    </form>
  );
}
